<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page two_step_reg">
      <div class="col-lg-12">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form"><img :src="getTranslations.project_logo_img" alt=""></div>
            <div class="form_title">
              <h1>{{ getTranslations.visitor_two_step_registration_send_sms }}</h1>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
              <img class="form-help__icon" src="/static/images/mobile-icon.svg" alt="">
            </div>
            <form action="">
              <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield phone_input"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check" v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a :href="getTranslations.project_config_visitor_register_3_terms_and_conditions" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>
              <input type="submit" :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( hasErrors || waitForResponse )? 'deactivated' : '']" @click.prevent="checkButton">
              <!--span class="form-group__code">$#You need a new unique code? <a href="#">$#Resend me a code</a></span-->
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';

export default {
  name: 'two-step-sign-up-1',
  mixins: [IntegrationMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getHeIntegration(to);
    });
  },
  created() {
    const inputMsisdn = this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    getHeIntegration(to) {
      this.getIntegrationParametersCheck()(to);
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${this.getRegistrationInfo}&lang=${this.getLocale}`).then((response) => {
        const resp = response.data.responseEnum;
        if (resp === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (resp === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (resp === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (resp === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (resp === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (resp === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (resp === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[a-zA-Z0-9]{0,10}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (!this.hasErrors && this.user.pin.length > 0 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        this.$axios.get(`api/verifyPin?pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}`).then((response) => {
          this.waitForResponse = false;
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setRegistrationInfo(response.data.data.msisdn);
            this.$gtm.trackEvent({
              event: 'CompleteRegistration',
              category: 'MSISDN Registration',
              action: 'Two Step Register 2 registration',
              label: 'Two Step Register 2',
            });
            this.$router.push('twostepregister2');
          } else {
            if (res === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (res === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_sign_up_msisdn_already_registered';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/TwoStepRegistration1.vue